module.exports = __webpack_public_path__ + "img/ic_money.ca5e58e6.svg";